import { module } from "angular";
import { merge } from "lodash";
import type { ISiteEquipmentWithCoverages } from "App/Modules/Models/Models/ISiteEquipmentWithCoverages";
import type { ISitesRepository } from "App/Modules/Repositories/Site/ISitesRepository";
import type { ISiteEquipmentRepository } from "App/Modules/Repositories/SiteEquipment/ISiteEquipmentRepository";
import { tap } from "rxjs/operators";
import type ISiteEquipmentListService from "./ISiteEquipmentListService";

export default class SiteEquipmentListService implements ISiteEquipmentListService {
    public static $inject: string[] = ["mmSitesRepository", "mmSiteEquipmentRepository"];

    private siteEquipmentList: ISiteEquipmentWithCoverages[] = [];

    constructor(
        private readonly sitesRepository: ISitesRepository,
        private readonly siteEquipmentRepository: ISiteEquipmentRepository,
    ) {}

    public fetchList(siteId: string) {
        return this.sitesRepository.getSiteEquipmentsWithCoveragesForSite(siteId).pipe(
            tap((response) => {
                if (response.data) {
                    this.siteEquipmentList = response.data;
                }
            }),
        );
    }

    public getSiteEquipment(siteEquipmentId: string) {
        return this.siteEquipmentList.find((se) => se.id === siteEquipmentId);
    }

    public refreshSiteEquipment(siteId: string, siteEquipmentId: string) {
        this.siteEquipmentRepository.getSiteEquipmentWithCoverages(siteId, siteEquipmentId).subscribe((response) => {
            const equipment = this.siteEquipmentList.find((se) => se.id === siteEquipmentId);

            if (!response.data || !equipment) {
                return;
            }

            merge(equipment, response.data);

            equipment.viewCoverages.forEach((vc) => {
                vc.functionalities.forEach((f) => {
                    f.videoStream = equipment.videoStreams.length > 0 ? equipment.videoStreams[0] : null;
                });
            });
        });
    }
}

module("mmManagePortal").service("irSiteEquipmentListService", SiteEquipmentListService);
